/* 2026-09-21: skeleton loaders sitewide. Escanea todas las <img>, marca
   skel-loaded en cuanto cada una termina de cargar (o al instante si ya
   estaba en cache al escanearla) para que assets/theme.css revele la
   imagen y quite el shimmer. Tambien observa el DOM por si se anaden
   imagenes despues (carrito, secciones cargadas por AJAX). */
(function () {
  function reveal(img) {
    img.classList.add('skel-loaded');
  }

  function watch(img) {
    if (img.dataset.skelSkip !== undefined) return;
    if (img.classList.contains('skel-loaded')) return;
    if (img.complete && img.naturalWidth > 0) {
      reveal(img);
      return;
    }
    img.addEventListener('load', function () { reveal(img); }, { once: true });
    img.addEventListener('error', function () { reveal(img); }, { once: true });
  }

  function scan(root) {
    (root || document).querySelectorAll('img').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IMG') {
            watch(node);
          } else if (node.querySelectorAll) {
            scan(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
